import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["items", "addButton"];
  static values = {
    reorderUrl: String,
    maxItems: { type: Number, default: 12 },
    debounceMs: { type: Number, default: 400 },
  };

  connect() {
    if (this.hasItemsTarget) {
      this.sortable = Sortable.create(this.itemsTarget, {
        animation: 150,
        handle: "[data-handle]",
        onEnd: () => this._persistOrder(),
      });
    }
    this._refreshAddButton();
  }

  disconnect() {
    this.sortable?.destroy();
  }

  wordChanged(event) {
    const input = event.target;
    const itemEl = input.closest("[data-item-id]");
    if (!itemEl) return;
    const url = itemEl.dataset.itemUpdateUrl;
    if (!url) return;

    clearTimeout(this._wordTimers?.[itemEl.dataset.itemId]);
    this._wordTimers ||= {};
    this._wordTimers[itemEl.dataset.itemId] = setTimeout(() => {
      this._patchWord(url, input.value, itemEl);
    }, this.debounceMsValue);
  }

  async _patchWord(url, word, itemEl) {
    const token = document.querySelector("meta[name=csrf-token]")?.content;
    const formData = new FormData();
    formData.append("item[word]", word);
    const res = await fetch(url, {
      method: "PATCH",
      headers: { Accept: "text/vnd.turbo-stream.html", "X-CSRF-Token": token || "" },
      body: formData,
    });
    if (res.ok) {
      const indicator = itemEl.querySelector("[data-validity-indicator]");
      if (indicator) {
        indicator.classList.remove("bg-content-disabled");
        indicator.classList.add(word.trim() ? "bg-success" : "bg-content-disabled");
      }
    }
  }

  async _persistOrder() {
    const ids = Array.from(this.itemsTarget.querySelectorAll("[data-item-id]"))
      .map((el) => el.dataset.itemId);
    const token = document.querySelector("meta[name=csrf-token]")?.content;
    const formData = new FormData();
    ids.forEach((id) => formData.append("ids[]", id));
    await fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token || "" },
      body: formData,
    });
  }

  _refreshAddButton() {
    if (!this.hasAddButtonTarget) return;
    const count = this.itemsTarget.querySelectorAll("[data-item-id]").length;
    this.addButtonTarget.classList.toggle("hidden", count >= this.maxItemsValue);
  }
}
